module.exports = __webpack_public_path__ + "img/course-bigcover05.adea42d9.png";